import * as actionTypes from '../actions/Actions';
export const redirectFromModalAction = () => ({
  type: actionTypes.REDIRECT_FROM_MODAL,
});

export const unRedirectFromModalAction = () => ({
  type: actionTypes.UN_REDIRECT_FROM_MODAL,
});
